import React from 'react';
import '../styles/Header.css';

const handleNavClick = (e, targetId) => {
  e.preventDefault();

  const root = document.getElementById('root');
  root.classList.add('fade-transition');

  setTimeout(() => {
    document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' });
    root.classList.remove('fade-transition');
  }, 600); // match with CSS transition
};

const Header = () => (
  <header className="header">
    <h1>My Portfolio</h1>
    <nav className="nav-links">
      <a href="#about" onClick={(e) => handleNavClick(e, 'about')}>About</a>
      <a href="#projects" onClick={(e) => handleNavClick(e, 'projects')}>Projects</a>
      <a href="#skills" onClick={(e) => handleNavClick(e, 'skills')}>Skills</a>
      <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')}>Contact</a>
    </nav>
  </header>
);

export default Header;
